<template>
  <div class="my-box">
    <div class="my-avatar-box">
      <div class="my-avatat-edit" @click="handleEdit"></div>
      <div class="my-avatar display_flex_center">
        <img :src="userinfo.avatar" alt />
      </div>
      <div class="my-user">{{userinfo.nickname}}</div>
      <div class="my-user-phone">{{userinfo.mobile}}</div>
    </div>
    <div class="my-service-box f_a_c">
      <div class="my-service-item" @click="routerPush('/my_doctor?status=my')">
        <div class="service-num">{{userinfo.mydoctor_num?userinfo.mydoctor_num:0}}</div>
        <div class="service-txt">我的医生</div>
      </div>
      <div class="my-service-item" @click="routerPush('/my_doctor?status=favorite')">
        <div class="service-num">{{userinfo.fandoctor_num?userinfo.fandoctor_num:0}}</div>
        <div class="service-txt">我的关注</div>
      </div>
      <div class="my-service-item" @click="routerPush('/my_issue')">
        <div class="service-num">{{userinfo.wenzhen_num?userinfo.wenzhen_num:0}}</div>
        <div class="service-txt">我的问诊</div>
      </div>
    </div>
    <div class="my-shop-list">
      <div class="my-shop-title display_flex_between" @click="routerPush('/my_shop_car')">
        <div class="my-shop-title-txt" >我的购药</div>
        <div class="my-shop-more-txt f_s_c">全部订单<img src="../../../static/img/all_in@3x.png" alt=""></div>
      </div>
      <div class="my-shop-img flex_around">
        <div class="shop-img-box display_flex_center" @click="handleToShop(1)">
          <img src="../../../static/img/paying@3x.png" alt="">
          <div class="shop-text">待支付</div>
          <span class="status-num" v-if="userinfo.status1num>0">{{userinfo.status1num}}</span>
        </div>
        <div class="shop-img-box display_flex_center" @click="handleToShop(2)">
          <img src="../../../static/img/pushing@3x.png" alt="">
          <div class="shop-text">待发药</div>
          <span class="status-num" v-if="userinfo.status2num>0">{{userinfo.status2num}}</span>
        </div> 
        <!-- <div class="shop-img-box display_flex_center" @click="handleToShop(3)">
          <img src="../../../static/img/pulling@3x.png" alt="">
          <div class="shop-text">待收货</div>
          <span class="status-num" v-if="userinfo.status3num>0">{{userinfo.status3num}}</span>
        </div> -->
        <div class="shop-img-box display_flex_center" @click="handleToShop(4)">
          <img src="../../../static/img/timeout@3x.png" alt="">
          <div class="shop-text">已超时</div>
          <span class="status-num" v-if="userinfo.status4num>0">{{userinfo.status4num}}</span>

        </div>
      </div>
    </div>
    <div class="my-option-list">
      <div class="my-option-title">常用工具</div>
      <div class="my-options display_flex_start" @click="routerPush('/patient_list')">
        <img src="../../../static/img/icon_ren@2x.png" alt />
        <div class="options-txt">常用就诊人</div>
        <div class="options-link"></div>
      </div>
      <div class="my-options display_flex_start" @click="routerPush('/address_list?from=my')">
        <img src="../../../static/img/icon_map@2x.png" alt />
        <div class="options-txt">地址管理</div>
        <div class="options-link"></div>
      </div>
      <div class="my-options display_flex_start" @click="handleCall">
        <img src="../../../static/img/kefu@2x.png" alt />
        <div class="options-txt">联系客服</div>
        <div class="options-link"></div>
      </div>
    </div>
    <tabbar />
  </div>
</template>

<script>
import tabbar from "../../components/tabbar/tabbar";
import http from "../../request/http";
import {getCustomerPhone} from '../../utils/index';
import login from '../../login'
export default {
  name: "my",
  data() {
    return {
      userinfo: {},
    };
  },
  components: {
    tabbar,
  },
  mounted() {
    this.imlogin();
    this.myinfo();

  },
  methods: {
    handleEdit() {
      this.$router.push("/user_edit");
    },
    routerPush(path) {
      this.$router.push(path);
    },
    myinfo() {
      http.post("/api/wap/user/myinfo",{
        api_token:''
      }).then((res) => {
        this.userinfo = res.data;
      });
    },
    handleCall() {
      if (this.$cookies.get("customer_phone")) {
        window.location.href = `tel:${this.$cookies.get("customer_phone")}`;
      }else{
        getCustomerPhone(this,(phone) => {
          window.location.href = `tel:${phone}`
        });
      }
    },
    imlogin(){
      if(!this.$cookies.get('app_token')){
        this.$toast.center('请先授权登录');
        login.login()
      }
    },
    handleToShop(num){
      this.$router.push('/my_shop_car?active_type='+num)
    }
  },
};
</script>

<style scoped>
@import "./my.css";
</style>



// WEBPACK FOOTER //
// src/pages/user/my.vue